import { render, staticRenderFns } from "./SpintowinGame.vue?vue&type=template&id=6f3dce3a&scoped=true&"
import script from "./SpintowinGame.vue?vue&type=script&lang=js&"
export * from "./SpintowinGame.vue?vue&type=script&lang=js&"
import style0 from "./SpintowinGame.vue?vue&type=style&index=0&id=6f3dce3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3dce3a",
  null
  
)

export default component.exports